import Icons from "@/src/components/Icons";
interface searchProps {
  searchTerm: any;
  setSearchTerm: any;
}
function SearchFood({ searchTerm, setSearchTerm }: searchProps) {
  return (
    <div className="search-box flex my-4">
      <div className="bg-primary-300 py-2 w-fit rounded-r-xl px-2 cursor-pointer">
        <Icons name="search" size={30} />
      </div>
      <input
        type="text"
        className="w-full border border-gray-100-mmpz p-3 rounded-l-xl"
        placeholder="جستجو.."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
}

export default SearchFood;
